(() => {
  angular.module('app').component('commonGuaranteeLettersDetailsRecentInpatientTicketsWidget', {
    templateUrl: require('./widget.html'),
    controller: RecentInpatientTicketsWidgetController,
    controllerAs: 'vm',
    bindings: {},
  });

  RecentInpatientTicketsWidgetController.$inject = [
    '$stateParams',
    'abp.services.app.guaranteeLetter',
  ];

  function RecentInpatientTicketsWidgetController($stateParams, guaranteeLetterSvc) {
    const vm = this;

    vm.loading = 0;

    init();

    function init() {
      getRecentInpatientTickets();
    }

    function getRecentInpatientTickets() {
      vm.loading += 1;
      guaranteeLetterSvc
        .getRecentInpatientTickets({
          id: $stateParams.letterNumber,
        })
        .success((data) => {
          vm.tickets = data.items;
          vm.ticketCount = vm.tickets.length;
        })
        .finally(() => {
          vm.loading -= 1;
        });
    }
  }
})();
